import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { useCart } from "@/lib/cart";

export default function OrderConfirmation() {
  const { t } = useI18n();
  const [searchParams] = useSearchParams();
  const { clearCart } = useCart();
  const orderId = searchParams.get("id") || searchParams.get("session_id");

  useEffect(() => { if (orderId) clearCart(); }, [orderId]);

  return (
    <div className="pt-24 pb-16">
      <div className="container max-w-lg text-center">
        <div className="animate-fade-in-up">
          <CheckCircle
            size={64}
            className="mx-auto mb-6"
            style={{ color: "var(--color-sage)" }}
          />
          <h1
            className="text-3xl mb-3"
            style={{ fontFamily: "var(--font-display)", color: "var(--color-charcoal)" }}
          >
            {t.orderConfirmation.title}
          </h1>
          <p className="text-lg mb-6" style={{ color: "var(--color-text-muted)" }}>
            {t.orderConfirmation.subtitle}
          </p>

          {orderId && (
            <p className="text-sm mb-4" style={{ color: "var(--color-text-light)" }}>
              {t.orderConfirmation.orderNumber}: <strong>#{orderId}</strong>
            </p>
          )}

          <p className="text-sm mb-8" style={{ color: "var(--color-text-muted)" }}>
            {t.orderConfirmation.emailSent}
          </p>

          <Link to="/gallery" className="btn-primary">
            {t.orderConfirmation.continueShopping}
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
